"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionCoverModalNoChildren = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_fela_1 = require("react-fela");
const VibescoutZIndexes_1 = require("../../../styling/VibescoutZIndexes");
const ForegroundFadeInBox_1 = require("./ForegroundFadeInBox");
const SimpleModalComponent_1 = require("./SimpleModalComponent");
const SectionCoverModalNoChildren = ({ 
// style,
// cssExtra = [],
// className = "",
getStateAndMessage = () => [SimpleModalComponent_1.EModalFeedbackState.LOADING, `Loading`], onClose, highZIndex = VibescoutZIndexes_1.ZIndexes.modalAboveAll, lowZIndex = -1, fadeTimeout = 500, loadingDelay = 0, position, }) => {
    // console.log(`Rendering section model no children`);
    const [fullyClosed, setFullyClosed] = (0, react_1.useState)(true);
    const [internalShow, setInternalShow] = (0, react_1.useState)(false);
    const { css, theme } = (0, react_fela_1.useFela)({ show: internalShow });
    const stateAndMessage = getStateAndMessage();
    const [currentState, currentMessage, ...rest] = stateAndMessage
        ? stateAndMessage
        : [SimpleModalComponent_1.EModalFeedbackState.NONE, ""];
    let forceTitle = undefined;
    if (rest.length > 0) {
        forceTitle = rest[0];
    }
    const show = currentState !== SimpleModalComponent_1.EModalFeedbackState.NONE;
    const delayedState = (0, react_1.useRef)({
        forceTitle: undefined,
        message: "",
        feedbackState: null,
        shouldUpdate: true,
        currentShowProp: show,
        onCloseFunction: onClose,
    });
    if (currentState !== SimpleModalComponent_1.EModalFeedbackState.NONE &&
        delayedState.current.feedbackState !== currentState) {
        delayedState.current.message = "";
        delayedState.current.feedbackState = null;
    }
    delayedState.current.currentShowProp = show;
    delayedState.current.onCloseFunction = onClose;
    const timeoutHolder = (0, react_1.useRef)(null);
    const loadingDelayTimeout = (0, react_1.useRef)(null);
    let modal;
    const runCloseSequence = (0, react_1.useCallback)((feedbackState, message, onCloseModal, positive = true, forceTitle) => {
        delayedState.current.forceTitle = forceTitle;
        delayedState.current.message = message;
        delayedState.current.feedbackState = feedbackState;
        if (delayedState.current.onCloseFunction) {
            delayedState.current.onCloseFunction(feedbackState, positive);
        }
        if (timeoutHolder.current != null) {
            clearTimeout(timeoutHolder.current);
        }
        setTimeout(() => {
            delayedState.current.message = "";
            delayedState.current.feedbackState = null;
        }, fadeTimeout);
        timeoutHolder.current = setTimeout(() => {
            if (delayedState.current.shouldUpdate) {
                setFullyClosed(true);
            }
        }, fadeTimeout);
        setInternalShow(false);
    }, [fadeTimeout]);
    switch (delayedState.current.feedbackState !== null ? delayedState.current.feedbackState : currentState) {
        case SimpleModalComponent_1.EModalFeedbackState.LOADING:
            modal = ((0, jsx_runtime_1.jsx)(SimpleModalComponent_1.SimpleModalComponent, { customHeader: delayedState.current.forceTitle || forceTitle, message: delayedState.current.message.length > 0 ? delayedState.current.message : currentMessage, feedbackState: SimpleModalComponent_1.EModalFeedbackState.LOADING, isFloating: true }));
            break;
        case SimpleModalComponent_1.EModalFeedbackState.ERROR:
            modal = ((0, jsx_runtime_1.jsx)(SimpleModalComponent_1.SimpleModalComponent, { customHeader: delayedState.current.forceTitle || forceTitle, message: delayedState.current.message.length > 0 ? delayedState.current.message : currentMessage, feedbackState: SimpleModalComponent_1.EModalFeedbackState.ERROR, isFloating: true, onClose: (fromState, positiveConfirmation) => runCloseSequence(fromState, currentMessage, onClose, positiveConfirmation, forceTitle) }));
            break;
        case SimpleModalComponent_1.EModalFeedbackState.CONFIRMATION:
            modal = ((0, jsx_runtime_1.jsx)(SimpleModalComponent_1.SimpleModalComponent, { customHeader: delayedState.current.forceTitle || forceTitle, message: delayedState.current.message.length > 0 ? delayedState.current.message : currentMessage, feedbackState: SimpleModalComponent_1.EModalFeedbackState.CONFIRMATION, isFloating: true, onClose: (fromState, positiveConfirmation) => runCloseSequence(fromState, currentMessage, onClose, positiveConfirmation, forceTitle) }));
            break;
        case SimpleModalComponent_1.EModalFeedbackState.ALERT:
            modal = ((0, jsx_runtime_1.jsx)(SimpleModalComponent_1.SimpleModalComponent, { customHeader: delayedState.current.forceTitle || forceTitle, message: delayedState.current.message.length > 0 ? delayedState.current.message : currentMessage, onClose: (fromState, positiveConfirmation) => runCloseSequence(fromState, currentMessage, onClose, positiveConfirmation, forceTitle), feedbackState: SimpleModalComponent_1.EModalFeedbackState.ALERT, isFloating: true }));
            break;
        default:
            modal = (0, jsx_runtime_1.jsx)("div", {});
    }
    (0, react_1.useEffect)(() => {
        delayedState.current.shouldUpdate = true;
        clearTimeout(loadingDelayTimeout.current);
        clearTimeout(timeoutHolder.current);
        if (show) {
            if (currentState === SimpleModalComponent_1.EModalFeedbackState.LOADING && loadingDelay > 0) {
                loadingDelayTimeout.current = setTimeout(() => {
                    if (delayedState.current.shouldUpdate && delayedState.current.currentShowProp) {
                        setInternalShow(true);
                        setFullyClosed(false);
                    }
                }, loadingDelay);
            }
            else {
                setInternalShow(true);
                setFullyClosed(false);
            }
        }
        else {
            setInternalShow(false);
            timeoutHolder.current = setTimeout(() => {
                if (delayedState.current.shouldUpdate) {
                    setFullyClosed(true);
                }
            }, fadeTimeout);
        }
        return () => {
            delayedState.current.shouldUpdate = false;
        };
    }, [show, currentState]);
    const zIndex = fullyClosed ? lowZIndex : highZIndex;
    return ((0, jsx_runtime_1.jsx)(ForegroundFadeInBox_1.ForegroundFadeInBox, { position: position, zIndex: zIndex, fadeTimeout: fadeTimeout, show: internalShow, children: modal })
    /*<FelaFlexbox
      align={"center"}
      justify={"center"}
      style={{
        zIndex,
        position: "absolute",
        transition: `background ${fadeTimeout}ms ease-in-out, backdrop-filter 0.3s ease-in-out, opacity 0.3s ease-in-out`,
        background: `rgba(${
          theme.dark ? theme.styles.Colors.darkBack.shadow[0] : theme.styles.Colors.lightBack.shadow[0]
        }, ${internalShow ? `0.55` : `0`})`,
        width: "100%",
        height: "100%",
        backdropFilter: "blur(2px)",
      }}>
      <FelaFlexbox
        align={"center"}
        justify={"center"}
        style={{
          transition: `opacity ${fadeTimeout}ms ease-in-out, transform ${fadeTimeout + 100}ms ease-in-out`,
          opacity: internalShow ? 1 : 0,
          transform: `translateY(${internalShow ? 0 : 35}%)`,
          position: "sticky",
          top: "40%",
          left: 0,
        }}>
        {modal}
      </FelaFlexbox>
      {/!*<FelaFlexbox
            // direction={"column"}
            // className={className}
            // cssExtra={cssExtra}
            style={{
              transition: "filter 0.3s ease-in-out",
              width: "100%",
              height: "100%",
              ...(internalShow && {
                backdropFilter: "blur(2px)",
              }),
              ...style,
            }}>

          </FelaFlexbox>*!/}
    </FelaFlexbox>*/
    );
};
exports.SectionCoverModalNoChildren = SectionCoverModalNoChildren;
